module.exports = __webpack_public_path__ + "static/media/import-example.0f1416cd.png";